import { createAsyncThunk } from "@reduxjs/toolkit";
import asyncInstance from "config/AsyncInstance";
import apiInstance from "config/axiosInstance";

export const GetAllBranchList = createAsyncThunk(
  "branch/GetAllBranchList",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post("settings/branchesList", body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const CreateBranch = createAsyncThunk(
  "branch/CreateBranch",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post("settings/branchesCreate", body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
export const ImportBranch = createAsyncThunk(
  "branch/ImportBranch",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post("settings/branchesimport", body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const GetIndividualBranch = createAsyncThunk(
  "branch/GetIndividualBranch",
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get(`settings/branchesView/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const DeleteBranch = createAsyncThunk(
  "practitioner/DeleteBranch",
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get(`settings/branchesDelete/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const GetAllBranchesData = createAsyncThunk(
  "practitioner/DeleteBranch",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get(`branchallList`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
